<template>
    <div class="city-selected">

        <div class="boxcity">
            <!-- 省市区的标题 点击可回退 -->
            <div class="chooseTit" v-if="this.level === 1">
                <p @click="chooseProvince" v-show='tit1'>{{chooseTit1}}</p>
                <p @click="chooseCity2" v-show='tit2'>{{chooseTit2}}</p>
                <p @click="chooseArea" v-show='tit3'>{{chooseTit3}}</p>
                <p @click="chooseTown" v-show='tit4'>{{chooseTit4}}</p>
                <p v-show='tit5'>{{chooseTit5}}</p>
            </div>
            <div class="chooseTit" v-if="this.level === 2">
                <p @click="chooseCity2" v-show='tit2'>{{chooseTit2}}</p>
                <p @click="chooseArea" v-show='tit3'>{{chooseTit3}}</p>
                <p @click="chooseTown" v-show='tit4'>{{chooseTit4}}</p>
                <p v-show='tit5'>{{chooseTit5}}</p>
            </div>
            <div class="chooseTit" v-if="this.level === 3">
                <p @click="chooseArea" v-show='tit3'>{{chooseTit3}}</p>
                <p @click="chooseTown" v-show='tit4'>{{chooseTit4}}</p>
                <p v-show='tit5'>{{chooseTit5}}</p>
            </div>
            <!-- 省市区 -->
            <div  class="citys">
                <div @click="getCity" class="province" v-if="this.level === 1">
                    <ul v-show="showProvince">
                        <li v-for="item in provinceL" :key="item.code" @click="getProvince(item)">{{item.name}}</li>
                    </ul>
                    <ul v-show="showCity2">
                        <li v-for="item in cityL" :key="item.code" @click="getCity2(item)">{{item.name}}</li>
                    </ul>
                    <ul v-show="showarea">
                        <li v-for="item in areaL" :key="item.code" @click="getarea(item)">{{item.name}}</li>
                    </ul>
                    <ul v-show="showtown">
                        <li v-for="item in townL" :key="item.code" @click="gettown(item)">{{item.name}}</li>
                    </ul>
                    <ul v-show="showvillage">
                        <li v-for="item in villageL" :key="item.code" @click="getvillage(item)">{{item.name}}</li>
                    </ul>
                    <!-- <ul v-show="showcountry">
                        <li v-for="item in countryL" :key="item.code">{{item.name}}</li>
                    </ul> -->
                </div>
                <div @click="getCity" class="province" v-if="this.level === 2">
                    <ul v-show="showCity2">
                        <li v-for="item in cityL" :key="item.code" @click="getCity2(item)">{{item.name}}</li>
                    </ul>
                    <ul v-show="showarea">
                        <li v-for="item in areaL" :key="item.code" @click="getarea(item)">{{item.name}}</li>
                    </ul>
                    <ul v-show="showtown">
                        <li v-for="item in townL" :key="item.code" @click="gettown(item)">{{item.name}}</li>
                    </ul>
                    <ul v-show="showvillage">
                        <li v-for="item in villageL" :key="item.code" @click="getvillage(item)">{{item.name}}</li>
                    </ul>
                </div>
                <div @click="getCity" class="province" v-if="this.level === 3">
                    <ul v-show="showarea">
                        <li v-for="item in areaL" :key="item.code" @click="getarea(item)">{{item.name}}</li>
                    </ul>
                    <ul v-show="showtown">
                        <li v-for="item in townL" :key="item.code" @click="gettown(item)">{{item.name}}</li>
                    </ul>
                    <ul v-show="showvillage">
                        <li v-for="item in villageL" :key="item.code" @click="getvillage(item)">{{item.name}}</li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import tmp from "@/common/tmp";
import http from "@/common/http";
export default {
    name: "citySelected",
    props: {
        optionList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        level: {
            type: Number,
            default: function() {
                return "";
            }
        },
        initLimit: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
    },
    data () {
        return {
            chooseCity:"点击选择城市",
            selected    : '',
            citySelected: '',
            areaSelected: '',
            townSelected: '',
            countryL : [],
            villageSelected: '',
            provinceL   : [],
            cityL       : [],
            areaL       : [],
            city        : [],
            townL: [],
            villageL : [],
            provinceName: '',
            cityName    : '',
            areaName    : '',
            townName: '',
            villageName: "",
            showProvince:true,
            showCity:true,
            showCity2:false,
            showarea:false,
            showtown: false,
            showvillage: false,
            showcountry : false,
            chooseTit1:"省",
            chooseTit2:"市",
            chooseTit3:"区/县",
            chooseTit4:"乡/镇",
            chooseTit5:"村",
            tit1:true,
            tit2:false,
            tit3:false,
            tit4:false,
            tit5:false,
            province:"",
            Nextcity:"",
            district:"",
            townDescription: "",
            village: "",
            totalCity:"",
        }
    },
    mounted() {
        console.error(this.optionList);
        console.error(this.cityL);
        console.error(this.level);
    },
    methods:{
        //点击省市标题隐藏出现内容  形成回退效果
        chooseProvince(){
            this.showProvince = true;
            this.showCity2 = false;
            this.showarea = false;
            this.showvillage = false;
            this.showtown = false;
            this.selected =  '';
            this.citySelected= '';
            this.areaSelected= '';
            this.townSelected= '';
            this.villageSelected= '';

            this.chooseTit2 = "市";
            this.chooseTit3 = "区/县";
            this.chooseTit4 = "乡/镇";
            this.chooseTit5 = "村";

        },
        chooseCity2(){
            this.showProvince = false;
            this.showCity2 = true;
            this.showarea = false;
            this.showtown = false;
            this.showvillage = false;
            this.citySelected= '';
            this.areaSelected= '';
            this.townSelected= '';
            this.villageSelected= '';

            this.chooseTit3 = "区/县";
            this.chooseTit4 = "乡/镇";
            this.chooseTit5 = "村";
        },
        chooseArea() {
            this.showProvince = false;
            this.showCity2 = false;
            this.showarea = true;
            this.showtown = false;
            this.showvillage = false;
            this.areaSelected= '';
            this.townSelected= '';
            this.villageSelected= '';

            this.chooseTit4 = "乡/镇";
            this.chooseTit5 = "村";
        },
        chooseTown() {
            this.showProvince = false;
            this.showCity2 = false;
            this.showarea = false;
            this.showtown = true;
            this.showvillage = false;
            this.townSelected= '';
            this.villageSelected= '';

            this.chooseTit5 = "村";
        },
        //点击省市区 让每个li内展示的名字等于数据的城市名
        getCity(){
            for(var item of this.provinceL){
                this.provinceName = item.name;
                this.selected = item.code;
                //this.regionId = item.regionId
            }
        },
        //当用户点击某个省事件 根据省的id获取市
        getProvince(item){
            console.log(this)
            this.province = item.name;
            this.chooseTit1 = item.name;
            this.selected = this.provinceL[0].code;
            let totalCity = this.province;
            this.chooseCity =totalCity;
            let totalCityId = this.selected + "";
            this.$emit('update', {name: totalCity,ids: totalCityId,level: 1})
            this.showProvince = false;
            this.showCity2= true;
            this.tit2 = true;
            this.cityL = item.subAddress;
                
            // console.log(item);

        },
        //当用户点击某个市事件 根据省的id获取区
        getCity2(item){
            console.log(this)
            this.Nextcity = item.name;
            this.chooseTit2 = item.name;
            this.areaL = item.subAddress;
            this.citySelected = item.code;
            let totalCity = this.province+"," + this.Nextcity;
            this.chooseCity =totalCity;
            let totalCityId = this.selected+"," + this.citySelected;
            this.$emit('update', {name: totalCity,ids: totalCityId,level: 2})
            this.showarea = true;
            this.showCity2= false;
            this.tit3 = true;
        },
        //用户点击区或者镇，遮罩消失
        getarea(item){
            console.log(this)
             let param = {
                pCode : item.code
            }
            // TODO
            http.get('/type/findByParentCode', param).then(res=> {
                 this.district = item.name;
                this.chooseTit3 = item.name;
                this.townL = res.data;
                this.areaSelected = item.code;
                let totalCity = this.province+"," + this.Nextcity +"," +this.district;
                this.chooseCity =totalCity;
                let totalCityId = this.selected+"," + this.citySelected +"," +this.areaSelected;
                this.$emit('update', {name: totalCity,ids: totalCityId,level: 3})
                this.showarea = false;
                this.tit4 = true;

                this.showtown = true;
            })
           

            // if(this.initLimit) {
            //     this.showtown = false;
            // }else {
            // }
           

        },
        gettown(item){
            let param = {
                pCode : item.code
            }
            http.get('/type/findByParentCode', param).then(res=> {
                console.log(res);
                this.townDescription = item.name;
                this.chooseTit4 = item.name;
                this.villageL = res.data;
                this.townSelected = item.code;
                let totalCity = this.province+"," + this.Nextcity +"," +this.district + "," + this.townDescription;
                this.chooseCity =totalCity;
                let totalCityId = this.selected+"," + this.citySelected +"," +this.areaSelected + "," + this.townSelected;
                this.$emit('update', {name: totalCity,ids: totalCityId,level: 4})
                this.showvillage = true;
                this.showtown = false;
                this.tit5 = true;
            });
           

        },
        getvillage(item) {
            console.log(this)
            if(item.level == 5) {
                // this.villageName = item.name;
                // this.chooseTit5 = item.name;
                // this.villageSelected = item.code;
                // let totalCity = this.province+"," + this.Nextcity +"," +this.district + "," + this.townDescription + "," + this.villageName;
                // this.chooseCity =totalCity;
                // let totalCityId = this.selected+"," + this.citySelected +"," +this.areaSelected + "," + this.townSelected + "," + this.villageSelected;
                // this.$emit('update', {name: totalCity,ids: totalCityId,level: 5})

                 this.lastName = item.name;
                this.chooseTit5 = item.name;
                this.lastSelected = item.code;
                console.log(this.province,this.Nextcity,this.district,this.townDescription,this.villageName);

                let totalCity = this.province+"," + this.Nextcity +"," +this.district + "," + this.townDescription + "," + this.lastName;
                this.chooseCity =totalCity;
                let totalCityId = this.selected+"," + this.citySelected +"," +this.areaSelected + "," + this.townSelected + "," + this.lastSelected;
                this.$emit('update', {name: totalCity,ids: totalCityId,level: 5})
                return;
            }
            let param = {
                pCode : item.code
            }

            http.get('/type/findByParentCode', param).then(res=> {
                this.villageL = res.data;
                console.log(this.countryL);
               
                this.villageName = item.name;
                this.chooseTit5 = item.name;
                this.villageSelected = item.code;
                let totalCity = this.province+"," + this.Nextcity +"," +this.district + "," + this.townDescription + "," + this.villageName;
                this.chooseCity =totalCity;
                let totalCityId = this.selected+"," + this.citySelected +"," +this.areaSelected + "," + this.townSelected + "," + this.villageSelected;
                this.$emit('update', {name: totalCity,ids: totalCityId,level: 5})

            })
            
        },
    },
    //页面初始化 请求数据 将请求到的城市保存下来
    created() {
        if (this.level === 1){
            this.provinceL = this.optionList;
            this.tit1 = true;
            this.showProvince = true;
        }else if (this.level === 2){
            this.cityL = this.optionList;
            this.tit2 = true;
            this.showCity2 = true;
        }else if (this.level === 3){
            this.areaL = this.optionList;
            this.tit3 = true;
            this.showarea = true;
        }
    },
}
</script>

<style scoped>

    .city-selected {
        z-index: 99999;
    }
    .chooseCity{
        width: 100%;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border-bottom: 1px solid #666;
    }
    .boxcity{
        position: absolute;
        width: 100%;
        right: 0;
        top:0;
        /* height: 200px; */
        z-index: 9900;
        background: #ffffff;
    }

    
    .citys{
        height: 145px;
        overflow: hidden;
        overflow-y: scroll;
        background: #ffffff;
    }
    .province{
        height: 100%;
    }
    /* 让滚动条不显示 */
    .citys::-webkit-scrollbar {
        display: none;
    }
    ul{
        margin:0;
        padding:0;
    }
    li{
        list-style: none;
        padding-top: 5px;
        padding-bottom: 5px;
        text-align: center;
    }
    .chooseTit {
        display: flex;
        height: 55px;
        justify-content: space-around;
        width: 100%;
        text-align: center;
        background: #448ff7;
    }
    .chooseTit p{
        color: #ffffff;
        width: 20%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }

</style>